import React from "react";
import { TextField } from "@mui/material";
import { getPointerEventsStyles, getReadOnlyStyles } from "../../lib/styles";

export function TextInput({ fieldConfig, controllerField, fieldState }) {
  const { readOnly } = fieldConfig;
  const { value, onChange, ...rest } = controllerField;

  return (
    <TextField
      {...rest}
      multiline
      type="text"
      disabled={readOnly}
      value={value || ""}
      onChange={(e) => onChange(e.target.value)}
      variant="outlined"
      size="small"
      error={!!fieldState.error}
      helperText={fieldState.error?.message}
      sx={getReadOnlyStyles(readOnly)}
      InputProps={{
        sx: getPointerEventsStyles(readOnly),
      }}
      fullWidth
    />
  );
}
